import React from "react";

function MicOffIcon() {
  return (    
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="24" viewBox="0 0 16 24">
  <g id="Group_18742" data-name="Group 18742" transform="translate(-523.146 -726.859)">
    <g id="Group_18741" data-name="Group 18741" transform="translate(523.146 726.859)">
      <path id="Subtraction_193" data-name="Subtraction 193" d="M10.732,24H4.407a.778.778,0,0,1,0-1.553h2.41V18.72a6.656,6.656,0,0,1-5.8-6.677v-.854a.723.723,0,0,1,.753-.757.723.723,0,0,1,.753.757v.854a5.194,5.194,0,0,0,5.045,5.2,4.917,4.917,0,0,0,3.621-1.61L9.943,14.348A3.309,3.309,0,0,1,7.57,15.3a3.318,3.318,0,0,1-2.226-.815,3.173,3.173,0,0,1-1.012-2.446V8.562L0,4.1l.691-.713L15.843,19.006l.157.157-.693.715L12.263,16.74a6.492,6.492,0,0,1-3.94,1.98v3.726h2.409a.778.778,0,0,1,0,1.553Zm2.688-8.923h0L12.274,13.9a5.2,5.2,0,0,0,.341-1.852v-.854a.753.753,0,1,1,1.506,0v.854a6.814,6.814,0,0,1-.7,3.033ZM10.795,12.37h0L4.332,5.706V3.319A3.14,3.14,0,0,1,7.57,0a3.14,3.14,0,0,1,3.238,3.319v8.724c0,.109,0,.219-.013.325Z" fill="#85888a"/>
    </g>
  </g>
</svg>

  );
}

export default MicOffIcon;
